/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  HERC721Logic,
  HERC721LogicInterface,
} from "../../../../contracts/dependant/erc721/HERC721Logic";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type HERC721LogicConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: HERC721LogicConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class HERC721Logic__factory extends ContractFactory {
  constructor(...args: HERC721LogicConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<HERC721Logic> {
    return super.deploy(overrides || {}) as Promise<HERC721Logic>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): HERC721Logic {
    return super.attach(address) as HERC721Logic;
  }
  override connect(signer: Signer): HERC721Logic__factory {
    return super.connect(signer) as HERC721Logic__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): HERC721LogicInterface {
    return new utils.Interface(_abi) as HERC721LogicInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): HERC721Logic {
    return new Contract(address, _abi, signerOrProvider) as HERC721Logic;
  }
}
